exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".clicks-1{fill:#faedb1}.clicks-2{fill:#1e4e69}.clicks-3{fill:#a6b1b9}\n", ""]);
